import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./src/assets/css/typography.css";
import "./src/assets/css/global.css";

export const onRouteUpdate = ({ location }) => {
    if (location.hash) {
        const id = location.hash.replace('#', '');
        const scrollToEl = () => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return true;
            }
            return false;
        };
        setTimeout(scrollToEl, 100);
        setTimeout(scrollToEl, 500);
        setTimeout(scrollToEl, 1200);
    }
};
